import { Button, Checkbox, Heading, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import type { PropsWithChildren } from 'react';
import type { I18nPrefix } from '../../../../i18n/prefix';

const COMPONENT = 'features:home.components.onboarding.checklist' satisfies I18nPrefix;

export function OnboardingChecklist({ children }: PropsWithChildren) {
  return (
    <div className="space-y-2 rounded-lg bg-spark-warning-soft px-4 py-5 shadow-sm sm:p-6">
      <Heading level="h3" style="sm">
        {t(`${COMPONENT}.title`)}
      </Heading>
      <Text variant="secondary" size="md">
        {t(`${COMPONENT}.description`)}
      </Text>
      <div className="mt-4 flex flex-col gap-4">{children}</div>
    </div>
  );
}

type ChecklistItemAction = { label: string } & ({ href: string } | { onClick: () => void });

export function OnboardingChecklistItem({
  label,
  description,
  action,
  learnMoreLink,
  checked,
  onChange,
}: {
  label: string;
  description?: string;
  action?: ChecklistItemAction;
  learnMoreLink?: string;
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <Checkbox label={label} description={description} checked={checked} onChange={onChange} />
        </div>
        {action && (
          <Button
            variant="secondary"
            size="sm"
            icon={'href' in action ? 'externalLink' : undefined}
            onClick={
              'href' in action
                ? () => window.open(action.href, '_blank', 'noopener,noreferrer')
                : action.onClick
            }
          >
            {action.label}
          </Button>
        )}
      </div>
      {learnMoreLink && (
        <div className="ps-6">
          <LearnMoreLink link={learnMoreLink} />
        </div>
      )}
    </div>
  );
}
